import type {WorkstreamMetric} from 'client';
import {getPrimaryNorthStarMetric} from 'views/workstreams/utils';

export const getStrategyKernelNorthStarMetric = (
  metrics: WorkstreamMetric[],
  workstreamId: number
) => getPrimaryNorthStarMetric(metrics, workstreamId);

export const formatStrategyKernelSixMonthPlanExport = ({
  northStarSummary,
  milestoneSummary,
  subworkstreamSummary,
}: {
  northStarSummary: string;
  milestoneSummary: string;
  subworkstreamSummary: string;
}) =>
  [
    `North Star Metric: ${northStarSummary || '-'}`,
    milestoneSummary ? `Milestones: ${milestoneSummary}` : '',
    subworkstreamSummary ? `Sub-Workstreams: ${subworkstreamSummary}` : '',
  ]
    .filter(Boolean)
    .join('; ');
